import * as React from "react"
export const Svg_036 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M11.135 42.56h35.73v13.137h-35.73V42.561Z" />
    <path
      fill="url(#b)"
      d="M0 49.936h7.737V42.56H4.519v-3.457h48.962v3.457h-3.218v7.375H58V27.502H0v22.434ZM46.684 31.27h3.398v3.457h-3.398V31.27Zm-6.797 0h3.398v3.457h-3.398V31.27Z"
    />
    <path
      fill="url(#c)"
      d="M46.865 3.303h-35.73v20.742h35.73V3.303ZM18.156 8.258h14.428v3.457H18.156V8.258ZM39.844 19.09H18.156v-3.457h21.688v3.457Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.398}
        x2={22.412}
        y1={44.531}
        y2={57.801}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={13.412}
        x2={18.8}
        y1={30.867}
        y2={53.41}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={19.398}
        x2={26.4}
        y1={6.414}
        y2={25.935}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)